import { isInApp } from '@utils/getEnv';
import { getStorage } from '@utils/localStorage';

const CUSTOMIZED_SHOW = getStorage('customizedShow') || '';

/** 隐藏打印设置 */
const PRINTER_CONFIG_HIDE = CUSTOMIZED_SHOW.indexOf('printConfig') !== -1;

type Imapping = {
    [key: string]: any;
};

const mapping: Imapping = {
    '/v2/shop/systemSettings':
        isInApp && !PRINTER_CONFIG_HIDE
            ? '/new_fe/business#/settings/printer'
            : '/v2/shop/systemSettings/r/reminder',
    '/v2/shop/msgbox': '/v2/shop/msgbox/business',
};

export default mapping;
